import {
  AbstractControl,
  AbstractControlOptions,
  AsyncValidatorFn,
  FormArray,
  FormGroup,
  ValidatorFn,
} from "@angular/forms";
import {WriteBackFormControl} from "./write-back-form-control";
import {KeyByObject} from "../misc/reduce-helpers";
import {getFormGroupFromJSONFormGroup, isJSONFormGroup} from "../json-shared.model";

const prohibitedKeys = {
  asyncValidator: true,
  validatorOrOpts: true,
};

function validatorOrOpts(thisArg: any, key: string): ValidatorFn | ValidatorFn[] | AbstractControlOptions | null {
  if (!thisArg.validatorOrOpts) return undefined;
  return thisArg.validatorOrOpts[key] || undefined;
}

function asyncValidator(thisArg: any, key: string): AsyncValidatorFn | AsyncValidatorFn[] | null {
  if (!thisArg.asyncValidator) return undefined;
  return thisArg.asyncValidator[key] || undefined;
}

function getSaneKeys(thisArg, keys?: string[]): string[] {
  if (!keys) keys = [];
  if (!keys.length) keys = Object.keys(thisArg);

  const allowedKeys: {[key: string]: boolean} = {};

  Object.keys(thisArg).forEach((key) => {
    if (typeof key !== "string" || /[\s.-]/.test(key)) return;
    if (prohibitedKeys[key]) return;
    if (typeof thisArg[key] === "function") return;
    allowedKeys[key] = true;
  });

  return keys.filter(it => !!allowedKeys[it]);
}

function getFormControl(thisArg, key) {
  if (isJSONFormGroup(thisArg[key])) return getFormGroupFromJSONFormGroup(thisArg[key]);

  return new WriteBackFormControl(thisArg, key, validatorOrOpts(thisArg, key), asyncValidator(thisArg, key));
}

function getFormControls(thisArg: any, keys?: string[]): {[p: string]: AbstractControl} {
  return getSaneKeys(thisArg, keys)
    .reduce((obj, key) => obj.add(key, getFormControl(thisArg, key)), new KeyByObject())
    .toObject();
}

function getArrayFormControls(thisArg: any[], keys?: string[]): AbstractControl[] {
  return thisArg.map(item => new QuickFormGroup(item, keys));
}

export class QuickFormGroup extends FormGroup {
  constructor(public thisArg: any, keys?: string[]) {
    super(getFormControls(thisArg, keys));
  }
}

export class QuickFormArray extends FormArray {
  static buildGroup(thisArg: any[], keys?: string[], name: string = "items") {
    return new FormGroup({
      [name]: new QuickFormArray(thisArg, keys),
    });
  }

  constructor(thisArg: any[], private keys?: string[]) {
    super(getArrayFormControls(thisArg, keys));
  }

  buildNewFormGroup(item: any) {
    return new QuickFormGroup(item, this.keys);
  }
}
